import SectionHeader from "@/components/feature/SectionHeader";

const features = [
  {
    icon: "ri-hand-coin-line",
    title: "完全免费",
    desc: "全站漫画免费在线阅读，无需付费、无需充值，优质内容零门槛畅享。",
  },
  {
    icon: "ri-hd-line",
    title: "高清画质",
    desc: "精选高清图源，画面清晰不糊脸，每一格的细节都经得起放大。",
  },
  {
    icon: "ri-refresh-line",
    title: "每日更新",
    desc: "连载作品每日准时更新，最新话第一时间上架，追更再也不迷路。",
  },
  {
    icon: "ri-user-unfollow-line",
    title: "无需注册",
    desc: "打开即读，免登录免下载，随时随地开卷阅读，通勤路上也不错过。",
  },
];

export default function Features() {
  return (
    <section className="bg-background-50 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeader
          title="为什么选择43423漫画网"
          subtitle="海量书友的安心之选，只为更好的免费阅读体验"
          align="center"
        />
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4 md:gap-4">
          {features.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-200/70 bg-background-100 p-5 text-center transition-all duration-300 hover:-translate-y-1 hover:border-primary-300/60"
            >
              <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary-50 text-xl text-primary-600">
                <i className={item.icon}></i>
              </span>
              <h3 className="mt-4 text-sm font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}